import { splitHttpUrls } from "@certn/utils";
import { Fragment } from "react";

import { Link } from "./Link";

type Props = {
  text: string;
  testID: string;
};

export function LinkifiedText({ text, testID }: Props) {
  return splitHttpUrls(text).map((segment, index) =>
    segment.kind === "url" ? (
      <Link
        key={index}
        href={segment.text}
        isNewTab
        linkStyle="monochrome"
        testID={`${testID}-${index}`}
      >
        {segment.text}
      </Link>
    ) : (
      <Fragment key={index}>{segment.text}</Fragment>
    )
  );
}
